import React, { HTMLAttributes, PropsWithChildren } from "react";
import { styled } from "@mui/material";
import { escRegExpSpecChars } from '@/utils/regexp';

const Highlight = styled('span')({
  backgroundColor: '#ffef5b',
});

export type HighlighterProps = {
  pattern: string | RegExp,
} & HTMLAttributes<HTMLSpanElement> & PropsWithChildren;

export const strToHighlightRegExp = (search: string): RegExp => {
  const pattern = escRegExpSpecChars(search);
  return new RegExp('(?<!\\S)' + pattern + '|^' + pattern, 'i');
};

const Highlighter = ({
  children,
  pattern,
  ...props
}: HighlighterProps) => {
  const text = children?.toString() || '';
  const re = (typeof pattern === 'string') ? strToHighlightRegExp(pattern) : pattern;

  const m = text.match(re);
  if (!!m) {
    const part1 = text.substring(0, m!.index!);
    const part2 = text.substring(m!.index!, m!.index! + m[0].length);
    const part3 = text.substring(m!.index! + m[0].length);
    return (<>{part1}<Highlight {...props}>{part2}</Highlight>{part3}</>);
  }
  return (<>{children}</>);
};

export default Highlighter;